import { css } from '@emotion/react';
import { Box, styled } from '@mui/joy';

import { transientOptions } from '@/utils/transient-options';

export const TableSearchFilterWrapper = styled(
  Box,
  transientOptions,
)<{ $sticky?: boolean }>(({ $sticky }) =>
  $sticky
    ? css`
        position: sticky;
        top: 0;
        z-index: 101;
      `
    : css``,
);
